<template>
  <div>
    <v-icon 
      v-if="!loading"
      class="download-log"
      @click="createFileRequest">
      mdi-download
    </v-icon>
    <v-progress-circular
      v-else
      indeterminate
      color="green"
    ></v-progress-circular>
  </div>
</template>

<script>

import { AmplifyEventBus } from "aws-amplify-vue";

import moment from "moment";

import { CreateDVRFileRequest } from "@/services/file-retrieval.js";

import { Logger } from "aws-amplify";
const logger = new Logger("RetrieveFileStateManager // ");

export default {
  name: 'RetrieveFileStateManager',
  props: {
    item: {
      type: Object,
      required: true
    },
    log: {
      type: Object,
      required: true
    },
    org: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  methods: {

    async createFileRequest() {
        this.loading = true;

        let device = null;
        let vehicleId = null;
        let currentDateTime = moment().format('YYYY-MM-DD HH:mm:ss');
        
        logger.info('item for logs ', this.item)
				// let deviceID = this.item.devices.find(device => {
				// 	return device.is_defaultdevice == true || device.is_default_device == true || device.is_default_device === "true"
				// });
          // Get device ID
        if(this.item.devices && this.item.devices.length > 0) {
          let defaultDevice = null;

          defaultDevice = this.item.devices.find(device => {
              return device.is_defaultdevice == true || device.is_default_device == true || device.is_default_device === "true" || device.is_default == 'True';
          });

          if (defaultDevice) {
            device = defaultDevice;
            vehicleId = this.item.id;
          }
        } else if (this.item.hasOwnProperty('is_default')) {
          device = this.item;
          vehicleId = device.vehicle_id;
        }
				const res = await CreateDVRFileRequest(
					this.org, vehicleId, device.device_id,
					{
						file_requests: [
							{
								file_type: 'log',
								file_name: this.log.name
							}
						],
						description: currentDateTime
					}
				)
				.then(() => {
          this.loading = false;

					AmplifyEventBus.$emit("snackEvent", {
						color: "success",
						text: `Log file request successfully created!`,
					});

				})
				.catch((err) => {
					AmplifyEventBus.$emit("snackEvent", {
						color: "error",
						text: err,
					});

          this.loading = false;
				});
				logger.info('called createFileRequest : ', res);
			}
  }
}
</script>